import React, { useState, useCallback } from 'react';
import View from '../../table/view'
import Button from '@mui/material/Button';
import { getUrl } from 'aws-amplify/storage';
import DownloadIcon from '@mui/icons-material/Download';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import dayjs from 'dayjs';
import { createReport, deleteReport, getReports, updateReport } from '../../slices/report.js';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import * as mutations from '../../graphql/mutations';
import { generateClient } from 'aws-amplify/api';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';

const Reports = () => {
  const columnDefs = [
    { field: 'id', headerName: 'Id', sortable: true, minWidth: 300, checkboxSelection: true },
    { field: 'startTime', formEnabled: true, type: 'text', headerName: 'Start Time', sortable: true, minWidth: 200 },
    { field: 'endTime', formEnabled: true, type: 'text', headerName: 'End Time', sortable: true, minWidth: 200, },
    { field: 'createdAt', formEnabled: true, type: 'text', headerName: 'Created At', sortable: true, minWidth: 200, },
    { field: 'type', formEnabled: true, type: 'text', headerName: 'Type', sortable: true, minWidth: 150, },
    {
      field: 'queryExecutionId',
      formEnabled: true,
      type: 'text',
      headerName: 'Report',
      sortable: true,
      minWidth: 60,
      renderCell: (params) => (
        <>
          <Button
            size="small"
            variant="contained"
            style={{ marginRight: 16 }}
            tabIndex={params.hasFocus ? 0 : -1}
            onClick={() => {

              const downloadFile = (url, filename) => {
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }

              const bucket_path = `${params.value}.csv`;
              getUrl({
                key: bucket_path,
                options: {
                  validateObjectExistence: true,  // Check if object exists before creating a URL
                  expiresIn: 20, // validity of the URL, in seconds. defaults to 900 (15 minutes) and maxes at 3600 (1 hour)
                  useAccelerateEndpoint: false // Whether to use accelerate endpoint
                },
              }).then((result) => {
                downloadFile(result.url.href, 'report.csv')
              });
            }}
          >
            <DownloadIcon />
          </Button>
        </>
      )
    },

  ];

  const date_format_string = "YYYY-MM-DD HH:mm:ss";
  const generate_label = 'Generate Report';
  const submitting_label = 'Submitting Report...'
  const first_day_of_month = dayjs().set('hour', 0).set('minute', 0).set('second', 0).startOf('month')
  const last_day_of_month = first_day_of_month.endOf('month').set('hour', 23).set('minute', 59).set('second', 59);
  const [startTime, setStartTime] = useState(first_day_of_month);
  const [endTime, setEndTime] = useState(last_day_of_month.toISOString());
  const [generateDisabled, setGenerateDisabled] = useState(false);
  const [generateButtonText, setGenerateButtonText] = useState(generate_label);
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const fetchReports = useCallback(() => {
    (async () => {
      try {
        await dispatch(getReports()).unwrap();
      } catch (err) {
        enqueueSnackbar(err.message, { variant: 'error' });
      }
    })();
  }, [dispatch, enqueueSnackbar]);

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid size={4} padding={2}>
              <DesktopDateTimePicker
                label={"Start"}
                open={isPickerOpen}
                onOpen={() => setIsPickerOpen(true)}
                onClose={() => setIsPickerOpen(false)}
                views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
                format={date_format_string}
                value={startTime}
                onChange={(newValue) => { setStartTime(newValue) }}
              ></DesktopDateTimePicker>
            </Grid>
            <Grid size={4} padding={2}>
              <DesktopDateTimePicker
                label={"End"}
                format={date_format_string}
                defaultValue={last_day_of_month}
                onChange={(newValue) => setEndTime(newValue)}
              ></DesktopDateTimePicker>
            </Grid>
            <Grid size={4} padding={2}>
              <Button size="large" variant="contained" startIcon={<AssessmentIcon />} onClick={() => {
                let client = generateClient();
                setGenerateDisabled(true);
                setGenerateButtonText(submitting_label)
                client.graphql({
                  query: mutations.generateReport,
                  variables: {
                    startTime,
                    endTime,
                    type: 'usage'
                  }
                })
                  .then(data => {
                    setGenerateDisabled(false);
                    setGenerateButtonText(generate_label)
                    fetchReports();
                    return items;
                  })
                  .catch(err => console.log(err))
                  ;
              }}
                disabled={generateDisabled}
              >
                {generateButtonText}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <View
          name="Reports"
          columnDefs={columnDefs}
          deleteFunction={deleteReport}
          getFunction={getReports}
          updateFunction={updateReport}
          createFunction={createReport}
          stateSelector={(state) => state.reports}
          addEnabled={false}
          deleteEnabled={true}
        />
      </LocalizationProvider>
    </>
  )
}

export default Reports;
